import { FormControl, FormGroup } from "@angular/forms";
import { MagicServices } from "@magic-xpa/angular";

export enum MgControlName {
  Username = "EDT_Usuario",
  Password = "EDT_Senha",
}

export class MgFormControlsAccessor {
  constructor(private fg: FormGroup, private magicServices: MagicServices) {}

  get Username(): FormControl {
    return <FormControl>this.fg.controls[MgControlName.Username];
  }

  get Password(): FormControl {
    return <FormControl>this.fg.controls[MgControlName.Password];
  }

  getTableChildFormControl(name: MgControlName): FormControl {
    return <FormControl>(
      this.magicServices.mgAccessorService.getFormGroupByRow(
        this.magicServices.tableService.getSelectedRow()
      ).controls[name]
    );
  }
}
